document.addEventListener("DOMContentLoaded", function(){

let inputs = document.querySelectorAll(".pc-pin")
let statusBox = document.getElementById("pc-status")

inputs.forEach((input,index)=>{

input.addEventListener("input", function(){

this.value = this.value.replace(/[^0-9]/g,'')

if(this.value !== "" && index < inputs.length-1){
inputs[index+1].focus()
}

checkPincode()

})

input.addEventListener("keydown", function(e){

if(e.key==="Backspace" && this.value==="" && index>0){
inputs[index-1].focus()
}

})

/* paste support */
input.addEventListener("paste", function(e){

let paste = (e.clipboardData || window.clipboardData).getData("text")
paste = paste.replace(/[^0-9]/g,'').slice(0,6)

if(paste.length === 6){
inputs.forEach((box,i)=>{
box.value = paste[i]
})
checkPincode()
}

})

})

function getPincode(){

let pin=""

inputs.forEach(input=>{
pin += input.value
})

return pin

}
function checkPincode(){

let pincode = getPincode()

if(pincode.length !== 6){
return
}

statusBox.className=""
statusBox.innerHTML="Checking delivery..."

fetch("https://pincode-checker-49ol.onrender.com/check-pincode",{

method:"POST",

headers:{
"Content-Type":"application/json"
},

body: JSON.stringify({pincode:pincode})

})
.then(res=>res.json())
.then(data=>{
let location = (data.city || "") + ", " + (data.state || "")

if(data.status==="available"){

statusBox.className="pc-success"

statusBox.innerHTML =
location + "<br>Congrats! You're eligible for 3hrs Xpress Delivery"

launchConfetti()

}else{

statusBox.className="pc-error"

statusBox.innerHTML =
location + "<br>Standard Delivery (6-7 days)"

}

})
.catch(()=>{

statusBox.className="pc-error"
statusBox.innerHTML="⚠️ Unable to check delivery right now"

})

}

function launchConfetti(){

const duration = 1500
const end = Date.now() + duration

;(function frame(){

const confetti = document.createElement("div")

confetti.style.position="fixed"
confetti.style.width="6px"
confetti.style.height="6px"
confetti.style.background =
["#ff5f5f","#f6b73c","#5fbf8f"][Math.floor(Math.random()*3)]

confetti.style.left=Math.random()*window.innerWidth+"px"
confetti.style.top="-10px"
confetti.style.borderRadius="50%"
confetti.style.zIndex="9999"

document.body.appendChild(confetti)

const fall = confetti.animate(
[{transform:"translateY(0px)"},{transform:"translateY(100vh)"}],
{duration:800,easing:"ease-out"}
)

fall.onfinish=()=>confetti.remove()

if(Date.now()<end){
requestAnimationFrame(frame)
}

})()

}

})
